export { SegmentedControl, SegmentedControlItem } from './segmented-control';
export type { SegmentedControlItemProps, SegmentedControlProps } from './segmented-control';
